
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';


@Injectable({
    providedIn: "root",
  })
  
  export class GlobalErrorHandler implements ErrorHandler {
    constructor(private injector: Injector, private zone: NgZone) {

    }

    handleError(error: any) {
         //console.log(error);
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;

        if (chunkFailedMessage.test(error.message)) {
          window.location.reload();
        }
        const router = this.injector.get(Router)
        if (error instanceof HttpErrorResponse) {

        

                if (error.status == 0) {
                     //console.log(error.message);
                    //return notificationService.error('Something went wrong with the server. Please try after sometime.', false, null, 5000);

                }

                if (error.status == 401) {
                    // window.sessionStorage.clear()
                    //auth.logout();
                    //window.location.href = '/login'
                     //console.log(error.message);
                    this.zone.run(() => router.navigate(["/Admin/account/login"]))
                    //return notificationService.error(`${error.statusText}`, false, null, 5000);
                }

                else {
                     //console.log(error.message);
                    //return notificationService.error(`${error.status} - ${error.statusText}`, false, null, 5000);
                }

            }
        
        else {
             //console.log(error)
            //notificationService.error('Client Error. Please try after sometime.', false, null, 5000);
        }

    }

}